import React, { useState, useEffect } from 'react';
import _ from 'lodash';

import CheckinTable from './CheckinTable';
import OrganizationApi from '../../api/organization';
import { CSVLink } from 'react-csv';
import Button from '../form/Button';
import Subnav from '../subnav';
import {statusColumns} from '../../utils'

import withEhsPageBehavior from '../../withEhsPageBehavior';
import './OrganizationStatusPage.scss';

const OrganizationStatusPage = (props) => {
    const [organization, setOrganization] = useState(null);
    const [criteria, setCriteria] = useState(null);
    const [rows, setRows] = useState([])
    const [columns, setColumns] = useState([])
    const [filePath, setFilePath] = useState('data.csv')
    const checkinKey = 'checkin';

    // What to sort the items by.
    const sortByString = 'code';

    useEffect(() => {
        const orgId = props.match.params.organizationId;

        // PROMISE ALL
        OrganizationApi.getCriteria(orgId).then((criteria) => {
            const newCriteria = {
                1: {},
                2: {},
                3: {},
                practices: criteria.practices,
            };

            [1, 2, 3].forEach((checkinNumber) => {
                // Get all of the values of the criteria for this checkin.
                const checkinCriteria = Object.values(criteria[checkinNumber]);

                // Sort the criteria by the sortByString
                const sortedCriteriaList = _.sortBy(
                    checkinCriteria,
                    sortByString
                );

                // Recreate the original criteria structure
                sortedCriteriaList.forEach((criterion) => {
                    newCriteria[checkinNumber][criterion.code] = criterion;
                });
            });

            setCriteria(newCriteria);
        });

        OrganizationApi.get(orgId).then((org) => {
            setOrganization(org);
        });
    }, []);

    const generateStatusColumns = () => {
      const columns = [];

      if (criteria && criteria.practices) {
        columns.push(
          ...statusColumns)

        const { practices } = criteria;
        const practiceNames = Object.keys(practices).map((key, i) => {
          const practice = practices[key];
          return {
            label: `${practice.abbreviation || practice.name}`,
            key: `${practice.id}`,
          };
        });

        columns.push(...practiceNames);
      } else {
        console.log('Error adding columns to CSV');
      }

      setColumns(columns);
      return columns;
    };

    const generateStatusRows = () => {
      let rowData = {};
      const cols = generateStatusColumns();
      const data = [];

      // Iterate over all the checkins (1, 2, 3)
      [1, 2, 3].forEach(checkin => {
        const listOfCriteria = Object.keys(criteria[checkin]);

        listOfCriteria.forEach(key => {
          const value = criteria[checkin][key];

          // Reset the row data.
          rowData = {};

          // Iterate through the columns and generate each row.
          cols.forEach(column => {
             if (!isNaN(+column.key)) {
               rowData[column.key] = value.practices[column.key].status;
             } else if (column.key === checkinKey) {
               rowData[checkinKey] = checkin;
             } else {
               rowData[column.key] = value[column.key];
             }
          });

          // Add this row to data.
          data.push(rowData);
        });
      });

      setRows(data);
    };

    const getCSVFilePath = () => {
      const org = organization ? organization.name : `Status.csv`;
      const filePath = `${org}_Status.csv`.replace(/ /g, '-');

      setFilePath(filePath);
    };

    const downloadCSV = async () => {
      await new Promise((resolve, reject) => {
        try {
          getCSVFilePath();
          generateStatusRows();
          generateStatusColumns();
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    };

    let orgName = 'Loading...';
    if (organization) {
        orgName = organization.name;
    }

    return (
      <div className="page">
        <div className="page__subnav">
          <Subnav organizationId={props.match.params.organizationId} />
        </div>

        <div className="page__header status__container">
          <h2>
            <i className="fa fa-sitemap" /> {orgName}{' '}
          </h2>
          <CSVLink
            onClick={downloadCSV}
            target="_self"
            filename={filePath}
            data={rows}
            headers={columns}>
            <Button icon="fa fa-download" defaultText="Download CSV" />
          </CSVLink>
        </div>

        <div className="page__body CheckinContainer">
          {['1', '2', '3'].map(checkinNumber => {
            if (criteria) {
              return (
                <CheckinTable
                  organization={organization}
                  key={checkinNumber}
                  sortByString={sortByString}
                  checkinNumber={checkinNumber}
                  label={`Checkin #${checkinNumber}`}
                  criteria={Object.values(criteria[checkinNumber])}
                  practices={criteria.practices}
                />
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
};

export default withEhsPageBehavior(OrganizationStatusPage);
